import React from 'react';
import * as searchTypes from '../../../constants/searchTypes';
import { HeaderRow, TableHeader } from 'components/common/tableElements';
import { handleError } from 'services/ErrorService/ErrorService';

const SearchResultHeader = ({ listType, zendeskConfig, orderingSystem }) => {
  const { SEARCH_ORDERS, SEARCH_SUBSCRIPTIONS } = searchTypes;

  switch (listType) {
    case SEARCH_ORDERS:
      switch (orderingSystem) {
        case 'shopify':
          if (zendeskConfig.isZendesk) {
            return null; // TO DO
          }

          return (
            <HeaderRow>
              <TableHeader>ORDER#</TableHeader>
              <TableHeader>CREATED AT</TableHeader>
              <TableHeader>NAME</TableHeader>
              <TableHeader>STATUS</TableHeader>
              <TableHeader>RISK</TableHeader>
            </HeaderRow>
          );
        case 'amazon':
          return (
            <HeaderRow>
              <TableHeader>ORDER#</TableHeader>
              <TableHeader>ITEMS</TableHeader>
              <TableHeader>STATUS</TableHeader>
            </HeaderRow>
          );
        case 'simplrOrder':
        case 'custom_rbi':
          return (
            <HeaderRow>
              <TableHeader>ORDER#</TableHeader>
              <TableHeader>CREATED AT</TableHeader>
              <TableHeader>NAME</TableHeader>
              <TableHeader>STATUS</TableHeader>
            </HeaderRow>
          );
        case 'salesforce':
          return (
            <HeaderRow>
              <TableHeader>ORDER#</TableHeader>
              <TableHeader>CREATED AT</TableHeader>
              <TableHeader>EST. SHIP DATE</TableHeader>
              <TableHeader>STATUS</TableHeader>
            </HeaderRow>
          );
        case 'customSeller':
          return (
            <HeaderRow>
              <TableHeader>EMAIL</TableHeader>
              <TableHeader>PLATFORM</TableHeader>
            </HeaderRow>
          );
        default:
          handleError({ customMessage: 'Invalid ordering system!' });

          return null;
      }
    case SEARCH_SUBSCRIPTIONS:
      return (
        <HeaderRow>
          <TableHeader>PRODUCT</TableHeader>
          <TableHeader>PRICE</TableHeader>
          <TableHeader>TYPE</TableHeader>
          <TableHeader>CREATED AT</TableHeader>
          <TableHeader>STATUS</TableHeader>
        </HeaderRow>
      );

    default:
      return null;
  }
};

export default SearchResultHeader;
